import { ImageStorageServicesBaseUrls } from '../constants/ImageConstants';

type Mask = 'ellipse';
type Format = 'auto';

interface ImageTransformations {
  height?: number;
  width?: number;
  mask?: Mask;
  format?: Format;
  quality?: number;
}

export const getImageCloudUrlWithTransformations = (
  imagePath: string,
  imageTransformations: ImageTransformations,
  baseURL = ImageStorageServicesBaseUrls.cloudFront
) => {
  const { height, width, mask, format, quality } = imageTransformations;

  const url = new URL(`${baseURL}/${imagePath}`);

  if (height) {
    url.searchParams.append('h', height.toString());
  }
  if (width) {
    url.searchParams.append('w', width.toString());
  }
  if (mask) {
    url.searchParams.append('mask', mask);
  }
  if (quality) {
    url.searchParams.append('q', quality.toString());
  }
  if (format) {
    url.searchParams.append('auto', 'format, compress');
  }

  return url.toString();
};
